/* Harold Speelhuisjes, productpagina B (sections/hsh-product-b.liquid).
   Wissel foto's en bovenaanzicht, fototeller, lightbox met <dialog> en de achterzijde.
   De achterzijde zet data-variant-id op #OfferteSamenstellen; het change-event bubbelt naar
   document, waar offerte.js het model daarna opnieuw onthoudt. */
(function () {
  var root = document.querySelector('[data-hsh-pdp]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var views = $$('[data-hsh-view]');
  views.forEach(function (b) {
    b.addEventListener('click', function () {
      views.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      $$('[data-hsh-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-hsh-panel') !== b.getAttribute('data-hsh-view'); });
    });
  });

  var gal = $('[data-hsh-gallery]'), teller = $('[data-hsh-teller]');
  if (gal && teller && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (e) { if (e.isIntersecting) teller.textContent = e.target.getAttribute('data-index'); });
    }, { root: gal, threshold: 0.6 });
    $$('[data-hsh-gallery] li').forEach(function (li) { io.observe(li); });
  }

  var lb = $('[data-hsh-lightbox]'), track = $('[data-hsh-track]');
  if (lb && track && typeof lb.showModal === 'function') {
    var naar = function (i) {
      var n = track.children.length;
      i = (i + n) % n;
      track.scrollTo({ left: track.children[i].offsetLeft, behavior: 'auto' });
    };
    var huidige = function () { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); };
    $$('[data-hsh-open]').forEach(function (b) {
      b.addEventListener('click', function () { lb.showModal(); naar(parseInt(b.getAttribute('data-hsh-open'), 10) || 0); });
    });
    $$('[data-hsh-stap]').forEach(function (b) {
      b.addEventListener('click', function () { naar(huidige() + parseInt(b.getAttribute('data-hsh-stap'), 10)); });
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') naar(huidige() + 1);
      if (e.key === 'ArrowLeft') naar(huidige() - 1);
    });
    $('[data-hsh-close]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.tagName === 'LI') lb.close(); });
  }

  var form = $('[data-hsh-variant-form]');
  var knop = document.getElementById('OfferteSamenstellen') || document.getElementById('KiesSpeelhuisje');
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || r.name !== 'id') return;
      if (knop) knop.setAttribute('data-variant-id', r.value);
      $$('[data-hsh-keuze]').forEach(function (p) { p.hidden = p.getAttribute('data-hsh-keuze') !== r.value; });
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', r.value);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (err) {}
    });
  }
})();
